import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../../utils/api/auth.service';
import { useAuth } from '../../../context/AuthContext';
import './QuickSignupModal.css';

export const QuickSignupModal = ({ isOpen, onClose, onSuccess }) => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showErrorModal, setShowErrorModal] = useState(false);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!formData.email || !formData.phone ) {
      setError('Please fill in all fields');
      return;
    }

  
    setLoading(true);
    setError(null);

    try {
      const response = await authService.signup({
        email: formData.email,
        phone: formData.phone,
        password: formData.email
      });

      // Auto-login after successful signup
      if (response.result) {
        login(response);
        onSuccess && onSuccess(response);
        onClose();
      }
    } catch (err) {
      console.error('Signup error:', err);
      // Show error modal for existing account
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  };

  const handleGoToLogin = () => {
    setShowErrorModal(false);
    onClose();
    navigate('/login');
  };

  const handleCloseErrorModal = () => {
    setShowErrorModal(false);
  };

  return (
    <>
      <div className="quick-signup-overlay" onClick={onClose}>
        <div className="quick-signup-modal" onClick={(e) => e.stopPropagation()}>
          <button className="quick-signup-close" onClick={onClose}>
            ×
          </button>

          <div className="quick-signup-header">
            <h2 className="quick-signup-title">Contact Details </h2>
            <p className="quick-signup-subtitle">This will help us to contact you</p>
          </div>

          <form className="quick-signup-form" onSubmit={handleSubmit}>
            <div className="quick-signup-field">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                disabled={loading}
              />
            </div>

            <div className="quick-signup-field">
              <label htmlFor="phone">Phone Number</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter your phone number"
                disabled={loading}
              />
            </div>

            

            {error && <p className="quick-signup-error">{error}</p>}

            <button 
              type="submit" 
              className="quick-signup-btn"
              disabled={loading}
            >
              {loading ? 'Creating Account...' : 'Sign Up & Continue'}
            </button>
          </form>

          <p className="quick-signup-login-link">
            Already have an account?{' '}
            <span onClick={handleGoToLogin}>Login here</span>
          </p>
        </div>
      </div>

      {/* Error Modal - Account Already Exists */}
      {showErrorModal && (
        <div className="error-modal-overlay" onClick={handleCloseErrorModal}>
          <div className="error-modal" onClick={(e) => e.stopPropagation()}>
            <div className="error-modal-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
            </div>
            <h3 className="error-modal-title">Account Already Exists</h3>
            <p className="error-modal-message">
              You already have an account with this email or phone number. Please login to continue.
            </p>
            <div className="error-modal-actions">
              <button className="error-modal-btn secondary" onClick={handleCloseErrorModal}>
                Try Again
              </button>
              <button className="error-modal-btn primary" onClick={handleGoToLogin}>
                Go to Login
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default QuickSignupModal;
